<div class="widget container mapPage">
  <app-customer-map></app-customer-map>
</div>
